// extracted by mini-css-extract-plugin
export default {"container":"AvoidScam_container__y6mxQ","heading":"AvoidScam_heading__j-at-","content":"AvoidScam_content__YOD60"};